import React from 'react';
import { CircularProgress, Stack, StackProps } from '@mui/material';
interface CenteredLoaderProps {
  height?: number | string;
  absolute?: boolean;
}

export const CenteredLoader = (props: CenteredLoaderProps & StackProps) => {
  const { height, absolute, ...rest } = props;
  const absoluteProps = absolute
    ? {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        style: {
          backdropFilter: 'blur(5px)',
        },
        backgroundColor: 'rgba(255,255,255,0.8)',
      }
    : {};
  return (
    <Stack
      width="100%"
      height={props.height || '100%'}
      alignItems="center"
      justifyContent="center"
      {...absoluteProps}
      {...rest}
    >
      <CircularProgress />
    </Stack>
  );
};
